// cards-carousel
import $ from "jquery";
import Flickity from "flickity-fade";
import "flickity-imagesloaded";

class CardsCarousel {
	constructor($el) {
		this.$el = $el;

		this.options = {
			// autoPlay: true,
			pageDots: false,
			wrapAround: true,
			prevNextButtons: true,
			freeScroll: false,
			cellSelector: ".cards-carousel__slide",
			cellAlign: 'left',
		};

		if (this.$el.length) {
			this._init();
		}
	}

	_init() {
        this.$slides = this.$el.find('.cards-carousel__slide');
        this.slidesCount = this.$slides.length;

        // console.log('Nombre de slides CARDS: ' + this.slidesCount);
		
		this._checkSlider();

		let resizeTimer;

		$(window).on("resize", () => {
			clearTimeout(resizeTimer);
			resizeTimer = setTimeout(() => {
				this._checkSlider();
			}, 200);
		});
    }

	_checkSlider() {
		const width = document.body.clientWidth;

		let shouldInit = false;

		if (width < 360 && this.slidesCount > 0) {
			shouldInit = true;
		} else if (width >= 360 && width < 690 && this.slidesCount > 1) {
			shouldInit = true;
		} else if (width >= 690 && width < 1040 && this.slidesCount > 2) {
			shouldInit = true;
		} else if (width >= 1040 && width < 1390 && this.slidesCount > 3) {
			shouldInit = true;
		} else if (width >= 1390 && this.slidesCount > 4) {
			shouldInit = true;
		}

		if (shouldInit && !this.slider) {
			this._createSlider();
			// console.log("Cards - slider init");
		}

		if (!shouldInit && this.slider) {
			this.slider.destroy();
			this.slider = null;
			this.$slides.css("height", "");
			// console.log("Cards - slider destroyed");
		}
	}

	_createSlider() {
		this.slider = new Flickity(this.$el[0], this.options);
	}
}

export default CardsCarousel;
